import graphql from 'babel-plugin-relay/macro'

export default graphql`
  query CompanyLayoutPreviewQuery($companyId: ID!, $companyLayoutId: ID!) {
    Me {
      Company(id: $companyId) {
        businessPost {
          data: companyLayout(id: $companyLayoutId) {
            id
            tableId
            preview
          }
        }
      }
    }
  }
`
